import { FC, useContext } from "react";
import { Flex, Paper, Text, useMantineTheme } from "@mantine/core";
import { CompetitionContext } from "../../../../CompetitionContext";
import { useCompetitionStats } from "../../../../hooks/useCompetitionStats";
import {
  IconBallFootball,
  IconCalendarStats,
  IconTarget,
} from "@tabler/icons-react";

interface StatCardProps {
  icon: React.ReactNode;
  value: string | number;
  label: string;
  color: string;
}

const StatCard: FC<StatCardProps> = ({ icon, value, label, color }) => {
  return (
    <Paper
      radius="md"
      p="sm"
      style={{
        flex: 1,
        minWidth: 80,
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `1px solid ${color}30`,
      }}
    >
      <Flex direction="column" align="center" gap={4}>
        <div style={{ color }}>{icon}</div>
        <Text fw={700} size="xl" style={{ lineHeight: 1, color }}>
          {value}
        </Text>
        <Text size="xs" c="dimmed" ta="center" style={{ lineHeight: 1.2 }}>
          {label}
        </Text>
      </Flex>
    </Paper>
  );
};

export const TournamentStats: FC = () => {
  const competitionId = useContext(CompetitionContext);
  const theme = useMantineTheme();

  const statsQuery = useCompetitionStats(competitionId);

  if (!statsQuery.isSuccess) {
    return null;
  }

  const stats = statsQuery.data;

  return (
    <Flex gap="xs" wrap="wrap">
      <StatCard
        icon={<IconCalendarStats size={20} />}
        value={`${String(stats.gamesFinished)}/${String(stats.gamesPlanned)}`}
        label="Spiele"
        color={theme.colors.fwcBlue?.[6] ?? theme.colors.blue[6]}
      />
      <StatCard
        icon={<IconBallFootball size={20} />}
        value={stats.totalGoals}
        label="Tore"
        color={theme.colors.green[6]}
      />
      <StatCard
        icon={<IconTarget size={20} />}
        value={stats.averageGoalsPerGame.toFixed(1)}
        label="Tore/Spiel"
        color={theme.colors.orange[6]}
      />
    </Flex>
  );
};
